import React, { useState, useContext } from 'react';
import styles from './NeedHelp.module.css';
import getClientContent from '../../_BrandingProvider/brandContent';
import { useClickOutside } from '../../_ReactHooks/useClickOutside';
import { BrandingContext } from '../../contexts/ContractContext';
import { stripPhoneNumber } from '../../shared/util';

const NeedHelp = () => {
    const branding = useContext(BrandingContext);
    const clientId = branding?.clientId || 'AIG';
    const clientIdLower = clientId?.toLowerCase();
    const { variableText } = getClientContent(clientId);
    const customerServicePhone = variableText?.customerService?.phone;
    const email = variableText.customerService.email;
    const [popUp, setPopUp] = useState(false);
    useClickOutside('NeedHelp', () => {
        setPopUp(false);
    });

    const open = (e) => {
        setPopUp(!popUp);
    };

    const close = (e) => {
        setPopUp(false);
    };

    return (
        <div
            className={styles.helpBtnWrapper}
            id='NeedHelp'
        >
            <button
                className={styles.helpBtn}
                aria-label='Need Help?'
                onClick={open}
            >
                Help
            </button>
            {popUp && (
                <div className={styles.helpTipText}>
                    <h1 className={`h4 mb-0 ${styles.helpHeading}`}>Speak to an Agent</h1>
                    <div className='mb-3'>
                        <div>
                            <a
                                href={`tel:${stripPhoneNumber(customerServicePhone)}`}
                                className='callLink pl-0'
                            >
                                {customerServicePhone}
                            </a>
                        </div>
                        <div>
                            <a
                                href={`mailto: ${email}`}
                                className='callLink pl-0'
                            >
                                {email}
                            </a>
                        </div>
                    </div>
                    {clientIdLower !== 'apple' && (
                        <>
                            <h1 className={`h4 mb-0 ${styles.helpHeading}`}>Have Questions?</h1>
                            <a
                                href='/faq'
                                target='_blank'
                                rel='noopener noreferrer'
                                className={styles.faqLink}
                            >
                                View FAQs
                            </a>
                        </>
                    )}
                    <button
                        type='button'
                        className={styles.close}
                        aria-label='Close'
                        onClick={close}
                    ></button>
                </div>
            )}
        </div>
    );
};

export default NeedHelp;
